import { IAccount, IVisibleUsers } from 'app/store/models/account.model';
import { DataSourceParams, ITableColumn } from 'app/store/models/table.model';
import { StaticDataSource } from 'app/datasources/static.datasource';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accounts-under',
  templateUrl: './accounts-under.component.html',
  styleUrls: ['./accounts-under.component.scss'],
})
export class AccountsUnderComponent implements OnInit {
  public items: any[];
  public ready = false;
  public account: IAccount;
  public emptyDataText = 'No data matching the filter.';

  dataSource: StaticDataSource<IVisibleUsers>;

  tableColumns: ITableColumn<IVisibleUsers>[] = [
    {
      id: 'first_name',
      title: 'First Name',
    },
    {
      id: 'last_name',
      title: 'Last Name',
    },
    {
      id: 'id',
      title: 'Account ID',
    },
    {
      id: 'email',
      title: 'Email',
    },
    {
      id: 'role',
      title: 'Role',
      renderer: row => {
        return row.role.charAt(0).toUpperCase() + row.role.slice(1);
      },
    },
  ];

  dataSourceParams: DataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'account_id',
    sortDir: 'desc',
    filters: {},
  };

  constructor() {
  }

  ngOnInit() {
    if (this.items) {
      if(this.account) {
        this.emptyDataText = `No subordinate users, assigned to this ${this.account.account_role}`;
      }
      this.dataSource = new StaticDataSource(this.items);
      this.ready = true;
    }
  }
}
